import type { ReactNode } from 'react';
import { Flex, NumberField, Stack, Text, Toggle } from '@customerio/pluma-components/react';

type ToggleRowProps = {
  title: string;
  description: string;
  isChecked: boolean;
  isDisabled?: boolean;
  onChange: (isChecked: boolean) => void;
};

export function ToggleRow({ title, description, isChecked, isDisabled, onChange }: ToggleRowProps) {
  return (
    <Flex alignItems="flex-start" justifyContent="space-between" gap="200">
      <Stack gap="025">
        <Text weight="bold">{title}</Text>
        <Text color="secondary" size="sm">
          {description}
        </Text>
      </Stack>
      <Toggle
        ariaLabel={title}
        size="sm"
        isChecked={isChecked}
        isDisabled={isDisabled}
        flexShrink="0"
        onChange={(event) => onChange(event.currentTarget.checked)}
      />
    </Flex>
  );
}

type DollarFieldProps = {
  label: string;
  isLabelHidden?: boolean;
  value: number | null;
  isInvalid: boolean;
  isDisabled?: boolean;
  /** Decimal places shown. Pluma's NumberField defaults to 0, which rounds $8.50 to 9. */
  precision?: number;
  elementAfter?: ReactNode;
  onChange: (value: number | null) => void;
};

export function DollarField({
  label,
  isLabelHidden,
  value,
  isInvalid,
  isDisabled,
  precision,
  elementAfter,
  onChange,
}: DollarFieldProps) {
  return (
    <NumberField
      label={isLabelHidden === true ? undefined : label}
      ariaLabel={isLabelHidden === true ? label : undefined}
      value={value ?? undefined}
      withControls={false}
      min={0}
      precision={precision}
      elementBefore={
        <Text color="secondary" pl="150">
          $
        </Text>
      }
      elementAfter={elementAfter}
      isInvalid={isInvalid}
      isDisabled={isDisabled}
      onChange={(next) => onChange(next ?? null)}
    />
  );
}
